import { render, staticRenderFns } from "./EmailMessage.vue?vue&type=template&id=c7f4118c"
import script from "./EmailMessage.vue?vue&type=script&lang=js"
export * from "./EmailMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports